module.exports = __webpack_public_path__ + "img/managed.851500fb.png";